import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import PageSEO from '../components/PageSEO';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <PageSEO title="Page Not Found | AI Search Advisers" isPrivate={true} />
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center space-y-6">
        <h1 className="text-7xl font-bold text-[#021426] tracking-tight">404</h1>
        
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-slate-900">Page Not Found</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            The page you're looking for doesn't exist or may have been moved.
          </p>
        </div>

        <div className="pt-4">
          <Button 
            onClick={() => navigate(localStorage.getItem('token') ? '/dashboard' : '/')}
            className="w-full bg-[#FEAB3D] hover:bg-[#e8960a] text-[#021426] font-semibold h-12 rounded-lg"
          >
            {localStorage.getItem('token') ? 'Go to Dashboard' : 'Go to Home'}
          </Button>
        </div>
      </div>
    </div>
  );
}
